module.exports = "<nv-react-component component=\"CourseAdminDashboard\"></nv-react-component>";